import {
  triggerAPI,
  qs,
  qsa,
  isInViewport,
  throttle,
  getBrowserDetails
} from './util';
import { isMobile } from './segment/segment-utils';
import lj from '../lumberjack';

lj.setupLJ();

let midExists =
  (window.razorpayAnalytics &&
    razorpayAnalytics.utils.getCookie('midExists')) ||
  false;

function validateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  alert('Please enter valid email address!');
  return false;
}
function validatePhonenumber(phoneno) {
  if (
    /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$/.test(
      phoneno
    )
  ) {
    return true;
  } else {
    alert('Please enter valid phone number!');
    return false;
  }
}

function handleFormSubmit(e) {
  const affordabilityWidgetForm = document.forms['affordability-widget-form'];
  e.preventDefault();
  const rm_options = document.getElementsByName('group1-radio');
  let registeredMerchant = 'no';
  for (let i = 0; i < rm_options.length; i++) {
    if (rm_options[i].checked) {
      registeredMerchant = rm_options[i].value;
    }
  }

  const ts_options = document.getElementsByName('group2-radio');
  let techStack = 'I am not sure';
  for (let i = 0; i < ts_options.length; i++) {
    if (ts_options[i].checked) {
      techStack = ts_options[i].value;
    }
  }

  if (
    !validateEmail(affordabilityWidgetForm.email.value) ||
    !validatePhonenumber(affordabilityWidgetForm.contact.value)
  ) {
    return false;
  }

  let isFormSubmit = true,
    hubspotPayload = {
      fields: [
        {
          name: 'firstname',
          value: `${affordabilityWidgetForm.full_name.value}`
        },
        {
          name: 'phone',
          value: `${affordabilityWidgetForm.contact.value}`
        },
        {
          name: 'email',
          value: `${affordabilityWidgetForm.email.value}`
        },
        {
          name: 'website',
          value: `${affordabilityWidgetForm.website.value}`
        },
        {
          name: 'do_you_have_a_razorpay_account_',
          value: registeredMerchant
        },
        {
          name: 'what_tech_stack_is_your_website_built_on_',
          value: techStack
        }
      ],
      context: {
        pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
        pageName: 'Razorpay Affordability widget'
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
            'I agree to allow Razorpay to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 6760497,
              text: 'I agree to receive marketing communications from Razorpay.'
            }
          ]
        }
      }
    };

  lj.pushEvents({
    event_name: 'website.form_filled',
    event_type: 'success',
    properties: {
      title: document.getElementsByTagName('title')[0].innerText,
      midExists,
      device_type: isMobile() ? 'mweb' : 'dweb'
    }
  });
  if (isFormSubmit) {
    triggerAPI(
      'https://api.hsforms.com/submissions/v3/integration/submit/5558946/514f4b8e-a986-425a-9e8c-335c7b639170',
      'POST',
      response => {
        qs('.after-success').classList.add('show');
      },
      hubspotPayload
    );
  }
}

qs('.affordability-widget-form').addEventListener('submit', handleFormSubmit);

// Append Video tag conditionally based on browser

// Create video element

// Use webm file for all browsers expect safari
// for safari use mp4

const browserDetails = getBrowserDetails();

const isDesktop = browserDetails.screen_width > 1023; //in px
const browser = browserDetails.browser;
const version = parseFloat(browserDetails.browser_version);
const videoSrc = {
  safari:
    '/assets/affordability-widget/hero-section/hero-illustration-video.mp4',
  others:
    '/assets/affordability-widget/hero-section/hero-illustration-video.webm'
};

const imgSrc = '/assets/affordability-widget/hero-section/illustration-web.png';

if (isDesktop && browser === 'safari' && version < 13) {
  const image = document.createElement('img');
  image.src = imgSrc;
  image.width = 600;
  image.height = 450;
  image.style.marginTop = '50px';
  image.style.maxHeight = 'unset';
  image.style.maxWidth = 'unset';
  qs('#illustration-video-container').appendChild(image);
} else if (isDesktop) {
  const video = document.createElement('video');
  video.controls = false;
  video.muted = true;
  video.autoplay = 'autoplay';
  video.loop = '1';
  video.height = 450; // in px
  video.width = 600; // in px
  video.style.marginTop = '30px';
  video.style.padding = '0px';
  video.style.scale = 1;
  if (browser === 'safari') {
    video.src = videoSrc.safari;
  } else {
    video.src = videoSrc.others;
  }
  qs('#illustration-video-container').appendChild(video);
}

qsa('.btn-explore-now').forEach(node => {
  node.addEventListener('click', e => {
    lj.pushEvents({
      event_name: 'affordability.widget.explore.payment.methods.cta',
      event_type: 'clicked',
      properties: {
        title: document.getElementsByTagName('title')[0].innerText,
        midExists,
        device_type: isMobile() ? 'mweb' : 'dweb'
      }
    });
  });
});

qsa('.top-banner-signup').forEach(node => {
  node.addEventListener('click', e => {
    lj.pushEvents({
      event_name: 'website.cta',
      event_type: 'clicked',
      properties: {
        title: document.getElementsByTagName('title')[0].innerText,
        midExists,
        device_type: isMobile() ? 'mweb' : 'dweb'
      }
    });
  });
});

qsa('#faqs .faqs-tab-title').forEach((node, idx) => {
  node.addEventListener('click', function(e) {
    lj.pushEvents({
      event_name: 'FAQs',
      event_type: 'clicked',
      properties: {
        title: document.getElementsByTagName('title')[0].innerText,
        midExists,
        device_type: isMobile() ? 'mweb' : 'dweb'
      }
    });
  });
});

window.addEventListener(
  'scroll',
  throttle(() => {
    if (isInViewport(qs('.faq-container'))) {
      lj.pushEvents({
        event_name: 'FAQs',
        event_type: 'viewed',
        properties: {
          title: document.getElementsByTagName('title')[0].innerText,
          midExists,
          device_type: isMobile() ? 'mweb' : 'dweb'
        }
      });
    }
  }, 1000),
  true
);
